import { useEffect, useState } from 'react';
import type { ColorMode } from '@xyflow/react';

function readColorMode(): ColorMode {
    return document.body.getAttribute('data-bs-theme') === 'light' ? 'light' : 'dark';
}

export function useColorMode(): ColorMode {
    const [mode, setMode] = useState<ColorMode>(readColorMode);

    useEffect(() => {
        const observer = new MutationObserver(() => setMode(readColorMode()));
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-bs-theme'] });
        return () => observer.disconnect();
    }, []);

    return mode;
}
